import styled from 'styled-components';
import { rem } from 'polished';
import { prefix } from '../../tools/settings';
import Avatar from '../Avatar';
import Chip from '../Chip';
import Caption from '../Caption';
import Paragraph from '../Paragraph';
var ActivityTimeline = styled.ul.withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimeline",
  componentId: "sc-1e1t8u9-0"
})(["list-style:none;margin:0;padding:0;"]);
var ActivityTimelineItem = styled.li.withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimelineItem",
  componentId: "sc-1e1t8u9-1"
})(["position:relative;+ .", "-activity-timeline__item{margin-top:24px;}"], prefix);
var ActivityTimelineItemHeader = styled.div.withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimelineItemHeader",
  componentId: "sc-1e1t8u9-2"
})(["display:flex;align-items:center;"]);
var ActivityTimelineItemInfo = styled.div.withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimelineItemInfo",
  componentId: "sc-1e1t8u9-3"
})(["display:flex;flex-direction:column;"]);
var ActivityTimelineItemMetadata = styled.div.withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimelineItemMetadata",
  componentId: "sc-1e1t8u9-4"
})([""]);
var ActivityTimelineItemMetadataText = styled(Paragraph).withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimelineItemMetadataText",
  componentId: "sc-1e1t8u9-5"
})(["display:inline;font-size:var(--dentsu-font-size-14) !important;line-height:", " !important;"], rem(20));
var ActivityTimelineItemContent = styled.div.withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimelineItemContent",
  componentId: "sc-1e1t8u9-6"
})(["padding-left:48px;"]);
var ActivityTimelineItemActions = styled.div.withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimelineItemActions",
  componentId: "sc-1e1t8u9-7"
})(["position:absolute;right:0;top:0;"]);
var ActivityTimelineItemAvatar = styled(Avatar).attrs({
  size: 'xxlarge'
}).withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimelineItemAvatar",
  componentId: "sc-1e1t8u9-8"
})(["margin-right:8px;"]);
var ActivityTimelineItemDescription = styled.div.withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimelineItemDescription",
  componentId: "sc-1e1t8u9-9"
})(["margin-top:4px;padding-right:48px;font-size:var(--dentsu-font-size-14);line-height:", ";color:var(--dentsu-color-black);overflow-wrap:anywhere;"], rem(20));
var ActivityTimelineItemStatus = styled(Chip).attrs({
  size: 'small',
  variant: 'status'
}).withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimelineItemStatus",
  componentId: "sc-1e1t8u9-10"
})(["max-width:none;margin:0 0 0 16px;span{margin:2px 0;font-size:12px;line-height:1;+ span{margin-left:4px;}}"]);
var ActivityTimelineItemDate = styled(Caption).attrs({
  isSecondary: true
}).withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimelineItemDate",
  componentId: "sc-1e1t8u9-11"
})([""]);
var ActivityTimelineItemAttachments = styled.div.withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimelineItemAttachments",
  componentId: "sc-1e1t8u9-12"
})(["padding-right:48px;"]);
var ActivityTimelineItemComments = styled.div.withConfig({
  displayName: "ActivityTimelinestyles__ActivityTimelineItemComments",
  componentId: "sc-1e1t8u9-13"
})([""]);
export var Styled = {
  ActivityTimeline: ActivityTimeline,
  ActivityTimelineItem: ActivityTimelineItem,
  ActivityTimelineItemAvatar: ActivityTimelineItemAvatar,
  ActivityTimelineItemDate: ActivityTimelineItemDate,
  ActivityTimelineItemInfo: ActivityTimelineItemInfo,
  ActivityTimelineItemHeader: ActivityTimelineItemHeader,
  ActivityTimelineItemMetadata: ActivityTimelineItemMetadata,
  ActivityTimelineItemMetadataText: ActivityTimelineItemMetadataText,
  ActivityTimelineItemContent: ActivityTimelineItemContent,
  ActivityTimelineItemDescription: ActivityTimelineItemDescription,
  ActivityTimelineItemStatus: ActivityTimelineItemStatus,
  ActivityTimelineItemActions: ActivityTimelineItemActions,
  ActivityTimelineItemAttachments: ActivityTimelineItemAttachments,
  ActivityTimelineItemComments: ActivityTimelineItemComments
};